import React, { useState, useRef, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { RenderIf } from '../../components/utils/RenderIf';
import QRCode from "react-qr-code";
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import imgCheck from "./img/check.gif"
import VendingModalVoucher from './VendingModalVoucher';
import { useWindowSize } from '../../hooks/useWindowSize';

function VendingModalConfirmation({ clearShoppingCart, orderCode, orderNumber, total, showModalConfirmation, setShowModalConfirmation, intervalNewOrder, voucher_Order, dataInfoPaymentSelect, setAtivityTimer, refresh, oledFinishConfirmation, inputConfirmation, newOrderTemperatureReady = true, newOrderTemperatureChecking = false }) {

    const [showModalvoucher, setshowModalvoucher] = useState(false);
    let routeQr = ""
    let branchoffice = ""
    if (localStorage.getItem('branchoffice_vending')) {
        if (localStorage.getItem('branchoffice_vending') != null || localStorage.getItem('branchoffice_vending') != '') {
            branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'))
            //routeQr = "192.168.1.5:3000/order/" + orderCode + "/branchoffice/" + branchoffice.id
            routeQr = "https://smartpay.ai/order/" + orderCode + "/branchoffice/" + branchoffice.id
        }
    }

    const newOrder = () => {
        if (newOrderTemperatureReady !== true) return;

        let message = "Gracias por su compra."
        let title = "Transaccion exitosa"
        let icon = 'success'

        clearShoppingCart(true)
        ErrorAlert(message, title, icon)
    }

    const handlercahge = (txt) => {

        if (txt == "1") {
            if (voucher_Order != "0") {
                setAtivityTimer(7)
                setshowModalvoucher(true)
            } else {
                if (newOrderTemperatureReady !== true) {
                    inputConfirmation.current.value = ""
                    return
                }

                inputConfirmation.current.value = ""
                newOrder()
            }
        } else {
            if (newOrderTemperatureReady !== true) {
                inputConfirmation.current.value = ""
                return
            }

            inputConfirmation.current.value = ""
            newOrder()
        }

    }

    useEffect(() => {
        if (showModalConfirmation == true) {

            const intervalConfirmation = setInterval(() => {
                inputConfirmation.current.focus()

            }, 2000);

            return () => clearInterval(intervalConfirmation);
        }


    }, [showModalConfirmation])
    //console.log(routeQr);

    const { width } = useWindowSize();
    const qrSize = width <= 480 ? "200" : "300";

    return (
        <>
            {/* showModalConfirmation */}
            <Modal
                show={showModalConfirmation}
                onHide={() => setShowModalConfirmation(true)}
                backdrop="static"
                fullscreen
            >

                <Modal.Body>

                    {/* <div onClick={() => setAtivityTimer(7)}>

                        <div className="">

                            <div className='my-4 py-2 border-vending-primary text-center'>
                                <h2 className=' fw-bold text-msg-footer '>Orden:
                                    <span className=' text-msg-footer fw-bold '>
                                        {orderNumber}
                                    </span>
                                </h2>

                            </div>

                            <div className="my-4 d-flex align-items-center justify-content-center border-vending-secondary py-4 position-relative">


                                <QRCode value={routeQr} size={qrSize} bgColor="#282c34" fgColor="#fff" level="H" />

                                <div className='position-absolute top-0 start-50 translate-middle border-vending-secondary px-4 bg-white'>
                                    <p className='fw-bold text-dark p-0 m-0'>Código QR</p>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between gap-2">

                                <div className=' py-2 border-vending-secondary text-center w-100'>
                                    <p className='  text-msg-footer text-dark'>Total de la orden:
                                        <span className=' fw-bold text-msg-footer text-dark text-uppercase d-block'>

                                            {total.toFixed(2)}
                                        </span>
                                    </p>
                                </div>
                                <div className=' py-2 border-vending-secondary text-center w-100'>
                                    <p className=' text-msg-footer text-dark'>Metodo de pago:
                                        <span className='fw-bold text-msg-footer text-dark text-uppercas d-block'>
                                            {dataInfoPaymentSelect}
                                        </span>
                                    </p>

                                </div>
                            </div>
                            <div className=' mt-2'>
                                <RenderIf isTrue={voucher_Order != "0"}>
                                    <h5 className='text-center text-msg-footer fw-bold'>Recibo de pago:</h5>
                                    <div className='mt-2 d-flex alight-item-center justify-content-center'>
                                        <VendingModalVoucher showModalvoucher={showModalvoucher} setshowModalvoucher={setshowModalvoucher} voucher_Order={voucher_Order}></VendingModalVoucher>
                                    </div>
                                </RenderIf>
                                <div className="m-3 d-flex align-items-center justify-content-center ">
                                    <button className='border-vending-primary p-3 fw-bold' onClick={() => newOrder()}>Nueva orden</button>
                                </div>

                                <input id="inputConfirmation" className='vending-input-qr' ref={inputConfirmation} inputMode="none" type="text" onChange={(e) => handlercahge(e.target.value)} autoFocus></input>

                            </div>
                        </div>
                    </div> */}


                    <div
                        className="vmc2-root"
                        onClick={() => setAtivityTimer(7)}
                    >

                        {/* Halo verde de éxito */}
                        <div className="vmc2-halo" />

                        {/* ========== HEADER ========== */}
                        <header className="vmc2-header">
                            <div className="vmc2-badge">
                                <span className="vmc2-badge-dot" />
                                <span>Orden confirmada</span>
                            </div>

                            <h1 className="vmc2-title">
                                Orden
                                <span className="vmc2-title-number">#{orderNumber}</span>
                            </h1>
                        </header>

                        {/* ========== CENTRO ========== */}
                        <main className="vmc2-main">

                            {/* QR Card destacado */}
                            <section className="vmc2-qr-card">
                                <div className="vmc2-qr-label">
                                    <i className="uil uil-qrcode-scan"></i>
                                    <span>Código QR</span>
                                </div>

                                <div className="vmc2-qr-wrap">
                                    <QRCode
                                        value={routeQr}
                                        size={qrSize}
                                        bgColor="#282c34"
                                        fgColor="#fff"
                                        level="H"
                                    />
                                </div>

                                <p className="vmc2-qr-hint">
                                    Escanea el QR para conservar tu comprobante
                                </p>
                            </section>

                            {/* Stats row: total + método de pago */}
                            <section className="vmc2-stats">
                                <div className="vmc2-stat">
                                    <span className="vmc2-stat-label">
                                        <i className="uil uil-bill"></i>
                                        Total de la orden
                                    </span>
                                    <span className="vmc2-stat-value vmc2-stat-value-amount">
                                        <small>$</small>{total.toFixed(2)}
                                    </span>
                                </div>

                                <div className="vmc2-stat">
                                    <span className="vmc2-stat-label">
                                        <i className="uil uil-credit-card"></i>
                                        Método de pago
                                    </span>
                                    <span className="vmc2-stat-value vmc2-stat-value-method">
                                        {dataInfoPaymentSelect}
                                    </span>
                                </div>
                            </section>

                            {/* Voucher */}
                            <RenderIf isTrue={voucher_Order != "0"}>
                                <section className="vmc2-voucher">
                                    <h3 className="vmc2-voucher-title">Recibo de pago</h3>
                                    <div className="vmc2-voucher-wrap">
                                        <VendingModalVoucher
                                            showModalvoucher={showModalvoucher}
                                            setshowModalvoucher={setshowModalvoucher}
                                            voucher_Order={voucher_Order}
                                        />
                                    </div>
                                </section>
                            </RenderIf>
                        </main>

                        {/* ========== FOOTER ========== */}
                        <footer className="vmc2-footer">
                            <button
                                className="vmc2-new-order-btn"
                                disabled={newOrderTemperatureReady !== true}
                                onClick={() => newOrder()}
                            >
                                <i className={newOrderTemperatureReady === true ? "uil uil-plus-circle" : "uil uil-sync"}></i>
                                <span>{newOrderTemperatureReady === true ? "Nueva Orden" : "Preparando máquina"}</span>
                            </button>
                            <p className="vmc2-footer-hint">
                                {newOrderTemperatureReady === true
                                    ? "Gracias por tu compra"
                                    : newOrderTemperatureChecking === true
                                        ? "Validando temperatura"
                                        : "Esperando disponibilidad"}
                            </p>
                        </footer>

                        {/* Input oculto — preservado */}
                        <input
                            id="inputConfirmation"
                            className="vmc2-hidden-input"
                            ref={inputConfirmation}
                            inputMode="none"
                            type="text"
                            onChange={(e) => handlercahge(e.target.value)}
                            autoFocus
                        />
                    </div>
                </Modal.Body>
            </Modal>


        </>
    )
}

export default VendingModalConfirmation
